import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/gy-apartment'

let api = {
  // 修改园区信息
  addCardBag: `${baseUrl}/cardBag/add`,

  // 修改园区信息
  addBackground: `${baseUrl}/cardBag/addBackground`,

  // 修改园区信息
  addForm: `${baseUrl}/cardBag/addForm`,

  // 修改园区信息
  addNavigate: `${baseUrl}/cardBag/addNavigate`,

  // 修改园区信息
  deleteNavigateByCodes: `${baseUrl}/cardBag/deleteNavigateByCodes`,

  // 修改园区信息
  getCardBag: `${baseUrl}/cardBag/getCardBag`,

  // 修改园区信息
  getNavigateList: `${baseUrl}/cardBag/getNavigateList`,

  // 修改园区信息
  getShowNavigate: `${baseUrl}/cardBag/getShowNavigate`,

  // 修改园区信息
  updateCardBag: `${baseUrl}/cardBag/update`,

  // 获取卡类型列表
  getCardTypeList: `${baseUrl}/cardType/getList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ConfigCard.js